import { Box, Text, View } from '@rbilabs/universal-components';

export const Disclaimer = Text.withConfig({
  variant: 'copyTwo',
  marginBottom: '$3',
});

export const ButtonWrapper = Box.withConfig({
  marginTop: '$3',
});

export const MarketDisclaimer = Text.withConfig({
  variant: 'copyTwo',
  marginBottom: '$4',
  textAlign: 'center',
});

export const SignUpContainer = View;

export const FieldContainer = Box.withConfig({
  marginBottom: '$1',
});

export const ErrorMessage = Text.withConfig({
  variant: 'copyOne',
  color: Styles.color.error,
  fontSize: 'xs',
});
